import { render, staticRenderFns } from "./uploadFileOfTask.vue?vue&type=template&id=bc5cc3a0&"
import script from "./uploadFileOfTask.vue?vue&type=script&lang=js&"
export * from "./uploadFileOfTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports